const state = {
  circleList: [],
  topicId: '', // 帖子id
  canComment: 1, // 帖子是否可评论
};

const mutations = {
  CHANGE_STATE: (state, obj) => {
    state = Object.assign(state, obj);
  },
  CHANGE_TOPIC_ID: (state, id) => {
    state.topicId = id;
  },
  CHANGE_CAN_COMMENT: (state, type) => {
    state.canComment = type;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
